export default {
  title: "Менеджеры",
  newPassRules1: "Должен содержать не менее 8 символов",
  appearAfterCreateManager: "Они появятся здесь после создания менеджера",
  canCreateManagerAfterConfirmEntity:
    "Создание менеджеров станет доступно после того, как ваше юрлицо пройдет модерацию",
  managerPassReset: "Пароль менеджера сброшен",
  writeDownLoginAndPass:
    "Внимание! Запишите логин и пароль для входа. При первой авторизации менеджеру необходимо будет создать новый пароль.",
  oneTimePass: "Одноразовый пароль",
  loginAndPassCopied: "Логин и пароль скопированы в буфер обмена",
  managerCreated: "Менеджер создан!",
  copyLoginAndPass: "Скопировать логин и пароль",
  sureToDeleteManager: "Вы уверены что хотите удалить менеджера?",
  editingManager: "Редактирование менеджера",
  creatingManager: "Создание менеджера",
  resetPassword: "Сбросить пароль",
  workPost: "Должность",
  accessToCabinetPages: "Доступ к страницам кабинета",
  deleteChanges: "Удалить внесенные изменения?",
  cancelManagerCreating: "Отменить создание менеджера?",
  ifNeedSaveGoBack:
    "Если необходимо их сохранить, вернитесь назад. Иначе все внесенные изменения не будут применены.",
  enteredInfoDontSave:
    "Внесенная информация не сохранится. Чтобы вернуться к редактированию, нажмите «Назад».",
  notLess8Chars: "Не менее 8 символов",
  requiredField: "Обязательное поле",
};
